module.exports = __webpack_public_path__ + "media/img/logos/2024/horizontal/vatertag-fdc47c8612ab8a989c59cded93c27c6d.svg";